import { createAsyncThunk } from '@reduxjs/toolkit';

import { IJobDTO } from 'src/api/dtos';
import JobRepository from 'src/api/repositories/ess/v1/job.repository';

export const fetchJobs = createAsyncThunk<IJobDTO[], void>('jobs', async (_, { rejectWithValue }) => {
  try {
    const repository = new JobRepository();
    return await repository.get();
  } catch (e) {
    return rejectWithValue(e);
  }
});
